import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const IPAnalysisHub = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default IPAnalysisHub